import React from "react";

class NotFound extends React.Component {
    render() {
        return <div>NotFoundvvvvvvvv</div>;
    }
}
export default NotFound;
